// Banner que muestra las alertas disparadas arriba del dashboard.
// - Se oculta si no hay nada disparado.
// - Cada chip lleva al tab correspondiente al hacerle clic.

import React from 'react';
import { Box, Paper, Typography, Chip, Stack } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const SEVERIDAD = {
    error:   { bg: '#ffebee', border: '#c62828', text: '#b71c1c', icon: <ErrorOutlineIcon /> },
    warning: { bg: '#fff3e0', border: '#ed6c02', text: '#e65100', icon: <WarningAmberIcon /> },
    info:    { bg: '#e3f2fd', border: '#0277bd', text: '#01579b', icon: <InfoOutlinedIcon /> },
};

const fmtValor = (valor, unidad) => {
    if (unidad === 'percent') return `${valor > 0 ? '+' : ''}${valor}%`;
    return Number(valor || 0).toLocaleString('es-AR');
};

export default function AlertasBanner({ alertas, meta, onIrATab }) {
    const disparadas = (alertas || []).filter(a => a.disparada);
    if (disparadas.length === 0) return null;

    // Ordenamos por severidad: error > warning > info
    const orden = { error: 0, warning: 1, info: 2 };
    disparadas.sort((a, b) => orden[meta[a.tipo]?.severidad || 'info'] - orden[meta[b.tipo]?.severidad || 'info']);

    // Tomamos la severidad más alta para el borde principal del banner
    const sevPrincipal = meta[disparadas[0].tipo]?.severidad || 'warning';
    const colors = SEVERIDAD[sevPrincipal];

    return (
        <Paper sx={{ p: 1.5, borderRadius: '4px', mb: 2, bgcolor: colors.bg, border: `2px solid ${colors.border}` }}>
            <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 0.5 }}>
                <Box sx={{ color: colors.text, display: 'flex' }}>{colors.icon}</Box>
                <Typography variant="caption" sx={{ fontWeight: 700, color: colors.text, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                    {disparadas.length === 1 ? '1 alerta activa' : `${disparadas.length} alertas activas`}
                </Typography>
            </Stack>
            <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap', gap: 1 }}>
                {disparadas.map(a => {
                    const m = meta[a.tipo] || {};
                    const sev = SEVERIDAD[m.severidad || 'warning'];
                    return (
                        <Chip
                            key={a.tipo}
                            label={
                                <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.75 }}>
                                    <Typography component="span" sx={{ fontWeight: 700, fontSize: '0.85rem' }}>
                                        {fmtValor(a.valorActual, m.unidad)}
                                    </Typography>
                                    <Typography component="span" sx={{ fontSize: '0.78rem' }}>
                                        {m.nombre}
                                    </Typography>
                                </Box>
                            }
                            onClick={() => onIrATab && m.tabDestino && onIrATab(m.tabDestino)}
                            sx={{
                                bgcolor: 'white', border: `1px solid ${sev.border}`, color: sev.text,
                                height: 'auto', py: 0.5, px: 0.5,
                                cursor: m.tabDestino ? 'pointer' : 'default',
                                '&:hover': m.tabDestino ? { bgcolor: sev.bg } : undefined,
                            }}
                        />
                    );
                })}
            </Stack>
        </Paper>
    );
}
